import { makes } from 'client/data/constants/active-makes';
import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: `/:make(${makes.join('|')})/:model/:year(\\d{4})/mpg`,
  exact: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "new_model_core_mpg" */ '../pages/mpg/mpg-definition')),
  chunkName: 'new_model_core_mpg',
  resolveLocationInParallelToPagePreload: true,
};
